module.exports = "<main class=\"gw-main-wrapper\">\r\n    <div class=\"gw-main\">\r\n        <div shown-when-loading class=\"gw-load-container\">\r\n            <div class=\"gw-loading-message\">\r\n                <gw-progress>\r\n                    <gw-progress-bounce></gw-progress-bounce>\r\n                </gw-progress>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</main>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/segmentation/demolandingpage/views/loadinglandingpage.html
// module id = 559
// module chunks = 0